import { selectedCohortState } from '@/modules/cohort/cohortSelection.js'
import { createCohortRealtimeGuard } from './realtimeAvailability.js'
import { refreshCohortSelection } from './cohortDiscovery.js'
import CohortLayout from '@/modules/cohort/CohortLayout.vue'
import { cohortFieldDictionaryRoute } from '@/modules/cohort/routeContracts.js'

export const cohortSelectorRoute = {
  path: '/cohorts',
  name: 'CohortSelector',
  component: () => import('@/modules/cohort/pages/CohortSelector.vue'),
  meta: { requiresAuth: true }
}

export const cohortRoute = {
  path: '/cohort',
  component: CohortLayout,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'CohortOverview',
      component: () => import('@/modules/cohort/pages/CohortOverview.vue')
    },
    {
      path: 'subjects',
      name: 'CohortSubjects',
      component: () => import('@/modules/cohort/pages/MonitoringOperations.vue')
    },
    {
      path: 'realtime',
      name: 'CohortRealtime',
      beforeEnter: async () => {
        try { await refreshCohortSelection() } catch (error) { console.warn('队列权限刷新失败', error); return '/cohort' }
        return createCohortRealtimeGuard(() => selectedCohortState.value)()
      },
      component: () => import('@/modules/cohort/pages/CohortRealtime.vue')
    },
    cohortFieldDictionaryRoute,
    {
      path: 'reports/night',
      name: 'CohortNightReport',
      component: () => import('@/modules/cohort/pages/CohortNightReport.vue')
    },
    {
      path: 'reports',
      name: 'CohortReports',
      component: () => import('@/modules/cohort/pages/CohortReportManagement.vue')
    }
  ]
}

export const cohortPrintRoute = {
  path: '/cohort/reports/print',
  name: 'CohortPrintReport',
  component: () => import('@/modules/cohort/pages/CohortNightReport.vue'),
  meta: { requiresAuth: true }
}
